import { AsyncStoreItem } from '@lib';
import { PostDeleteCompanionRequest } from 'src/sdk_checkin';

/**
 * CheckinDeleteCompanionResult model
 */
export interface CheckinDeleteCompanionResultModel {
  model: any;
}

/**
 * PostDeleteCompanionRequest model details
 */
export interface CheckinDeleteCompanionResultStateDetails extends AsyncStoreItem {}

/**
 * CheckinDeleteCompanionResult store state
 */
export interface CheckinDeleteCompanionResultState
  extends CheckinDeleteCompanionResultStateDetails,
    CheckinDeleteCompanionResultModel {}

/**
 * Name of the CheckinDeleteCompanionResult Store
 */
export const CHECKIN_DELETE_COMPANION_RESULT_STORE_NAME = 'checkinDeleteCompanionResult';

/**
 * CheckinDeleteCompanionResult Store Interface
 */
export interface CheckinDeleteCompanionResultStore {
  /** CheckinDeleteCompanionResult state */
  [CHECKIN_DELETE_COMPANION_RESULT_STORE_NAME]: CheckinDeleteCompanionResultState;
}
